// extracted by mini-css-extract-plugin
export var appSlider = "tech_index-module--app-slider--1UJbI";
export var content = "tech_index-module--content--2-oUK";
export var contentWrapper = "tech_index-module--content-wrapper--xhHY5";
export var defaultContainer = "tech_index-module--default-container--vpM8b";
export var desc = "tech_index-module--desc--2-S3c";
export var featureSlider = "tech_index-module--feature-slider--17yQF";
export var history = "tech_index-module--history--3rqcn";
export var innerPagesSlider = "tech_index-module--inner-pages-slider--321cH";
export var leftAppSlide = "tech_index-module--left-app-slide--mf60K";
export var logoSlider = "tech_index-module--logo-slider--3eR31";
export var phoneAppSelect = "tech_index-module--phone-app-select--1oNyc";
export var phoneCaseSelect = "tech_index-module--phone-case-select--OYQ9D";
export var rightAppSlide = "tech_index-module--right-app-slide--IKFgS";
export var slickActive = "tech_index-module--slick-active--CawVV";
export var slickArrow = "tech_index-module--slick-arrow--1KrlY";
export var slickCenter = "tech_index-module--slick-center--36w3R";
export var slickDots = "tech_index-module--slick-dots--1J_Pz";
export var slickNext = "tech_index-module--slick-next--3aMFO";
export var slickPrev = "tech_index-module--slick-prev--2xLCt";
export var slickSlide = "tech_index-module--slick-slide--2ZzUX";
export var slickSlider = "tech_index-module--slick-slider--2J9jj";
export var slickTrack = "tech_index-module--slick-track--3O3Rh";
export var solvingSlider = "tech_index-module--solving-slider--2XsV3";
export var stack = "tech_index-module--stack--3qofG";
export var stackContainer = "tech_index-module--stack-container--2CgAc";
export var stackGradient = "tech_index-module--stack-gradient--3DJwo";
export var stackItem = "tech_index-module--stack-item--2NAq0";
export var stackItemContainer = "tech_index-module--stack-item-container--gNYkQ";
export var stackItemTech = "tech_index-module--stack-item-tech--11bsj";
export var titleWrapper = "tech_index-module--title-wrapper--2yK6P";